import * as XLSX from 'xlsx';

/* Raw decimal hours*/
const formatHours = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n) || n <= 0) return '—';
  return `${Number(n.toFixed(2))} h`;
};

export const ATTENDANCE_SUMMARY_EXPORT_COLUMNS = [
  { key: 'ServiceNo', label: 'Service No', width: 15 },
  { key: 'Name', label: 'Name', width: 25 },
  { key: 'CompanyWorkingDays', label: 'Company Working Days', width: 20, numeric: true },
  { key: 'AttendanceDays', label: 'Attendance Days (All)', width: 20, numeric: true },
  { key: 'WorkingDays', label: 'Working Days (Week)', width: 20, numeric: true },
  { key: 'OffDays', label: 'Off Days', width: 12, numeric: true },
  { key: 'ExtraDays', label: 'Extra Days', width: 12, numeric: true },
  { key: 'TotalHours', label: 'Total Hours', width: 14, time: true },
  { key: 'NormalHours', label: 'Normal Hours', width: 14, time: true },
  { key: 'OTHours', label: 'OT Hours', width: 12, time: true },
  // { key: 'PreShiftOTHours', label: 'Pre OT Hours', width: 14, time: true },
  // { key: 'PostOTHours', label: 'Post OT Hours', width: 14, time: true },
  { key: 'Designation', label: 'Designation', width: 22 },
  { key: 'Department', label: 'Department', width: 22 },
  { key: 'EmploymentCategory', label: 'Category', width: 18 },
  { key: 'Location', label: 'Location', width: 25 },
];

function pad2(n) { return String(n).padStart(2, '0'); }

function stamp(d = new Date()) {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())} ` +
    `${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`;
}

export function exportAttendanceSummaryToExcel({ rows, filters }) {
  const activeFilters = Object.entries(filters || {})
    .filter(([, v]) => v && v !== 'All')
    .map(([k, v]) => `${k}: ${v}`)
    .join('   |   ') || 'None';

  const headerRows = [
    ['ATTENDANCE SUMMARY DETAILS'],
    [`Filters: ${activeFilters}`],
    [`Generated: ${stamp()}`],
    [`Records: ${rows.length}`],
    [],
  ];

  const columnHeader = ATTENDANCE_SUMMARY_EXPORT_COLUMNS.map((c) => c.label);

  const bodyRows = rows.map((r) =>
    ATTENDANCE_SUMMARY_EXPORT_COLUMNS.map((c) => {
      const v = r[c.key];

      if (c.key === 'ExtraDays') {
        const n = Number(v);
        if (!Number.isFinite(n)) return 0;
        return Math.max(0, n);
      }

      // Hour columns → "7.77 h"
      if (c.time) return formatHours(v);

      if (c.numeric) return Number(v) || 0;
      return v === null || v === undefined ? '' : v;
    })
  );

  const round2 = (n) => Math.round(n * 100) / 100;
  const totalsRow = ATTENDANCE_SUMMARY_EXPORT_COLUMNS.map((c) => {
    if (c.key === 'ServiceNo') return `TOTAL — ${rows.length} record${rows.length === 1 ? '' : 's'}`;
    if (c.key === 'AttendanceDays') return round2(rows.reduce((s, r) => s + (Number(r.AttendanceDays) || 0), 0));

    // Hour columns"
    if (c.time) {
      const total = rows.reduce((s, r) => s + (Number(r[c.key]) || 0), 0);
      return formatHours(total);
    }

    return '';
  });

  const aoa = [...headerRows, columnHeader, ...bodyRows, [], totalsRow];
  const ws = XLSX.utils.aoa_to_sheet(aoa);

  ws['!cols'] = ATTENDANCE_SUMMARY_EXPORT_COLUMNS.map((c) => ({ wch: c.width || 12 }));

  const lastCol = ATTENDANCE_SUMMARY_EXPORT_COLUMNS.length - 1;
  ws['!merges'] = headerRows
    .slice(0, 4)
    .map((_, i) => ({ s: { r: i, c: 0 }, e: { r: i, c: lastCol } }));

  ws['!freeze'] = { xSplit: 2, ySplit: headerRows.length + 1 };

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Attendance Summary');

  const out = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([out], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const d = new Date();
  const filename = `Attendance_Summary_${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}.xlsx`;

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);

  return filename;
}